import React from 'react';
import PropTypes from 'prop-types';

const PageWrapperBtn = ({ children }) => (
  <div className="flex md:flex-row flex-col gap-2 w-full md:w-max">
    {children}
  </div>
);

PageWrapperBtn.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export default PageWrapperBtn;
